<template>
  <!-- Form Errors -->
  <div class="alert alert-danger" v-if="errorList.length > 0">
    <p class="mb-0"><strong>Something went wrong!</strong> Correct the following and try again.</p>
    <br>
    <ul class="mb-0">
      <li v-for="error in errorList">
        {{ error }}
      </li>
    </ul>
  </div>
</template>
<script>
  export default{
    props: ['errorList']
  }
</script>
